import axios from 'axios';

const apiBaseURL = window.APP_CONFIG.API_BASE_URL;


export const apiClient = axios.create({
    baseURL:`${apiBaseURL}/api`,
    timeout: 5000
});

//拦截器：为所有该js发出的请求携带token
apiClient.interceptors.request.use(
    (config)=>{
        const token = localStorage.getItem('token');
        if(token){
            config.headers['Authorization'] = `Bearer ${token}`; //关键：添加JWT token
        }
        return config;
    },
    (error)=>Promise.reject(error) // 继续让后续的 .catch() 处理
)

//新增响应拦截器，统一处理4xxx报错，因为anxios可能自己处理，无法传递到业务层的catch中
apiClient.interceptors.response.use(
    (response)=>response, //正常响应直接返回
    (error) =>{
        if(error.response && error.response.status === 401){
        
                localStorage.removeItem('token'); //清除无效token
                alert('Token已过期，请重新登陆！')
                window.location.href = '/login'; // 跳转登录页
        }
        return Promise.reject(error); //网络错误或无响应
    }
)


//业务层

//发布文章
export const publishPost = (form)=>{
    return apiClient.post(`/admin/post`,form);
}

//删除文章
export const deletePost = (id)=>{
    return apiClient.delete(`/admin/posts/${id}`);
}

//更新文章
export const updatePost = (form)=>{
    return apiClient.put(`/admin/post`,form);
}

export const fetchArticleVariants = () => apiClient.get('/posts', {
    params: { currentPage: 1, pageSize: 200, lang: 'all' },
});

export const fetchAdminProfile = () => apiClient.get('/admin/profile');
export const updateAdminProfile = (profile) => apiClient.put('/admin/profile', profile);

export const fetchAdminProjects = () => apiClient.get('/admin/projects');
export const fetchAdminProject = (slug) => apiClient.get(`/admin/projects/slug/${encodeURIComponent(slug)}`);
export const createProject = (project) => apiClient.post('/admin/projects', project);
export const updateProject = (id, project) => apiClient.put(`/admin/projects/${id}`, project);
export const updateProjectStatus = (id, status) => apiClient.patch(`/admin/projects/${id}/status`, { status });
export const deleteProject = (id) => apiClient.delete(`/admin/projects/${id}`);

export const uploadMedia = (file, category = 'articles') => {
    const data = new FormData();
    data.append('file', file);
    data.append('category', category);
    return apiClient.post('/admin/media', data, {
        timeout: 20000,
    });
};


